import React, { FC, ReactNode } from "react";
import cx from "classnames";
import { CurrencyType, currencyMap } from "../../../types";
import { ActionButton } from "../../../../../Atoms/ActionButton/ActionButton";
import { dataTestIds } from "data-testids";

interface IPriceInfoBlockProps {
  value: number;
  title: ReactNode;
  variant: "primary" | "secondary";
  name?: ReactNode;
  currencySymbol?: string;
  paymentPeriod?: string;
  vatPrice?: string;
  pricePrefix?: string;
  priceSuffix?: string;
  svgIcon?: ReactNode;
  onIconClick?: (
    event:
      | React.MouseEvent<HTMLAnchorElement>
      | React.KeyboardEvent<HTMLAnchorElement>
  ) => void;
}

const infoBoxesClassNames =
  "flex gap-2 md:items-center justify-between rounded-md flex-col md:flex-row";

const PriceInfoBlock: FC<React.PropsWithChildren<IPriceInfoBlockProps>> = ({
  name,
  currencySymbol = currencyMap[CurrencyType.GBP],
  value,
  title,
  paymentPeriod,
  variant,
  vatPrice,
  pricePrefix,
  priceSuffix,
  svgIcon,
  onIconClick,
}) => {
  return (
    <div
      className={cx(infoBoxesClassNames, {
        "bg-color-brand-two p-4 text-white": variant === "primary",
        "bg-color-neutral-four px-4 py-2": variant === "secondary",
      })}
      data-testid={
        dataTestIds.componentLibrary[
          "Organisams.Billing.AddOnCheckout.PriceInfoBlock.PlanDetail"
        ]
      }
    >
      <div className="flex flex-col items-start gap-1">
        <p className="font-secondary self-start md:text-[22px]">{title}</p>
        {name && <p className="text-lg">{name}</p>}
      </div>
      <div className="flex items-center gap-3">
        <div className="flex flex-col gap-1 md:items-center">
          <p
            className={cx("text-lg", {
              "md:text-[26px]": variant === "primary",
              "md:text-[22px] md:leading-none": variant === "secondary",
            })}
            data-testid={
              dataTestIds.componentLibrary[
                "Organisams.Billing.AddOnCheckout.PriceInfoBlock.PriceDetail"
              ]
            }
          >
            {pricePrefix} {currencySymbol}
            {value.toFixed(2)} {priceSuffix} {paymentPeriod}
          </p>
          {vatPrice && (
            <div
              className={cx("text-m whitespace-nowrap", {
                "text-white": variant === "primary",
                "text-color-neutral-one": variant === "secondary",
              })}
            >
              {vatPrice}
            </div>
          )}
        </div>
        {svgIcon && onIconClick && (
          <ActionButton svgIcon={svgIcon} onClick={onIconClick} size="small" />
        )}
      </div>
    </div>
  );
};

export default PriceInfoBlock;
